import { hooks } from '@yola/ws-sdk';
import constants from '../constants';
import trackEvent from './track-event';

const trackWidgetDuplicated = () => {
  hooks.operations.subscribe(
    hooks.availableHooks.ON_AFTER_BLOCK_DUPLICATED,
    ({
      blockId,
      variationId: blockVariationId,
      constraintId,
      targetBlockId,
      targetBlockVariationId,
    }) => {
      if (blockId && !blockId.startsWith('widget-')) return;

      trackEvent(constants.events.WIDGET_DUPLICATED, {
        targetBlockId,
        targetBlockVariationId,
        blockId,
        blockVariationId,
        constraintId,
      });
    }
  );
};

export default trackWidgetDuplicated;
